import PushSettings from "../../components/PushSettings";
import adminPushApi from "../pushApi";
import { Bell, Volume2 } from "lucide-react";
import { playNotificationSound } from "../../lib/notificationSounds";

const SOUND_PREVIEWS = [
  { event: "new_order", label: "Nova encomenda", desc: "Sininho duplo (D5 → A5)" },
  { event: "order_pr", label: "Encomenda paga (PR)", desc: "Ka-ching (arpejo E-G♯-B + brilho)" },
];

export default function AdminNotifications() {
  return (
    <div className="max-w-3xl mx-auto p-4 sm:p-6" data-testid="admin-notifications-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl bg-[#0F1829] text-white grid place-items-center">
          <Bell size={18} />
        </div>
        <div>
          <h1 className="text-2xl font-semibold text-[#0F1829]" style={{ fontFamily: "'Fraunces', serif" }}>
            Notificações do Browser
          </h1>
          <p className="text-sm text-[#6B7280]">
            Recebe alertas em tempo real no browser quando entram novas encomendas ou quando passam a Pagamento Recebido (PR), mesmo com a aplicação fechada.
          </p>
        </div>
      </div>

      <div className="rounded-2xl bg-[#FFF8E6] border border-[#F5DC8C] p-4 mb-6 text-sm text-[#5C4A1F]">
        <p className="font-medium mb-1">Como funciona</p>
        <ul className="list-disc pl-5 space-y-0.5 text-[13px]">
          <li>Activa as notificações neste dispositivo (browser).</li>
          <li>O sistema verifica novas encomendas e mudanças para PR a cada 2 minutos.</li>
          <li>Cada evento gera um alerta — clica para abrir o painel.</li>
          <li>Funciona em desktop (Chrome/Edge/Firefox) e iOS 16.4+ (precisa de instalar como PWA).</li>
        </ul>
      </div>

      <PushSettings api={adminPushApi} scope="admin" />

      <div className="rounded-2xl border border-[#E6E1D6] bg-white p-5 mt-5" data-testid="admin-sound-previews">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-10 h-10 rounded-xl bg-[#F5F2EB] text-[#0F1829] grid place-items-center">
            <Volume2 size={18} />
          </div>
          <div>
            <h3 className="text-base font-semibold text-[#0F1829]" style={{ fontFamily: "'Fraunces', serif" }}>
              Sons das notificações
            </h3>
            <p className="text-xs text-[#6B7280] mt-0.5">
              Cada tipo de evento toca um som diferente quando o painel está aberto. Clica para pré-escutar.
              <br />
              <span className="text-[11px] text-[#978D78]">Nota: o browser exige uma interacção tua antes de permitir reproduzir áudio — clica num dos botões abaixo uma vez para destrancar.</span>
            </p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 gap-3">
          {SOUND_PREVIEWS.map((s) => (
            <button
              key={s.event}
              type="button"
              data-testid={`sound-preview-${s.event}`}
              onClick={() => playNotificationSound(s.event)}
              className="flex items-center gap-3 p-3 rounded-xl border border-[#E6E1D6] bg-[#FAF8F3] hover:bg-[#F5F2EB] hover:border-[#0F1829] transition text-left"
            >
              <div className="w-8 h-8 rounded-full bg-[#0F1829] text-white grid place-items-center shrink-0">
                <Volume2 size={14} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-[#0F1829]">{s.label}</p>
                <p className="text-[11px] text-[#6B7280]">{s.desc}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
